import { useEffect, useState } from "react";
import { Stage, Layer } from "react-konva";
import { Group, Line, Rect, Text, Circle } from 'react-konva';
import { handleStageWheel, cursorGrab, handleStageDragMoveComn, handleStageDragStart, renderPcsComn } from '../../../utils/DiagramParts';
import LoadImage from "../../../commons/LoadImage";
import { Col } from 'reactstrap';
import { getDeviceConfig } from "../../../api/api";
import Spinner from "../../../commons/Spinner";


const ComnKoshigaya = (props) => {

    const [scene, setScene] = useState({ width: window.innerWidth, height: window.innerHeight - 150 });
    const [stageScale] = useState(0.40);
    const [isLoading, setIsLoading] = useState(true);
    const authToken = localStorage.getItem('accessToken');
    const [deviceList, setDeviceList] = useState({

        batArr: [
            { device_id: 'BTPCS 2-1', ip_address: '12.2.2.2', work_status: 0 },
            { device_id: 'BTPCS 2-2', ip_address: '', work_status: 0 },
            { device_id: 'BTPCS 2-3', ip_address: '', work_status: 0 },
            { device_id: 'BTPCS 2-4', ip_address: '', work_status: 0 },
            { device_id: 'BTPCS 2-5', ip_address: '', work_status: 0 },
            { device_id: 'BTPCS 2-6', ip_address: '', work_status: 0 },
            { device_id: 'BTPCS 2-7', ip_address: '', work_status: 0 },
            { device_id: 'BTPCS 2-8', ip_address: '', work_status: 0 },
            { device_id: 'BTPCS 2-9', ip_address: '', work_status: 0 },
            { device_id: 'BTPCS 2-10', ip_address: '', work_status: 0 },
            { device_id: 'BTPCS 2-11', ip_address: '', work_status: 0 },
            { device_id: 'BTPCS 2-12', ip_address: '', work_status: 0 },
        ],
        pcsArr: [
            { device_id: 'PCS 1-1', ip_address: '', work_status: 0 },
            { device_id: 'PCS 1-2', ip_address: '', work_status: 0 },
            { device_id: 'PCS 1-3', ip_address: '', work_status: 0 },
            { device_id: 'PCS 1-4', ip_address: '', work_status: 0 },
            { device_id: 'PCS 1-5', ip_address: '', work_status: 0 },
            { device_id: 'PCS 1-6', ip_address: '', work_status: 0 },
            { device_id: 'PCS 1-7', ip_address: '', work_status: 0 },
            { device_id: 'PCS 2-1', ip_address: '', work_status: 0 },
            { device_id: 'PCS 2-2', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-1', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-2', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-3', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-4', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-5', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-6', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-7', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-8', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-9', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-10', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-11', ip_address: '', work_status: 0 },
            { device_id: 'PCS 3-12', ip_address: '', work_status: 0 },
        ],
        hybridPcs: [{
            device_id: "PV_50KW_PCS_1", ip_address: '', work_status: 0
        }]

    });

    useEffect(() => {
        if (props.deviceId !== null) {
            const controller = new AbortController();
            const signal = controller.signal;
            const fetchDevices = async (signal) => {
                setIsLoading(true);
                const data = await getDeviceConfig(authToken, props.deviceId, { configType: 'network_config' }, signal);
                if (data.length > 0) {
                    const hybridPcs = data.filter(el => el.device_id.toLowerCase().includes('50'));
                    const multiMeter = data.filter(el => el.device_id.toLowerCase().includes('mmr'));
                    const weather = data.filter(el => el.device_id.toLowerCase().includes('wmr'));
                    const batArr = data.filter(el => el.device_id.toLowerCase().startsWith('btpcs')
                    ).sort((a, b) => a.device_id.localeCompare(b.device_id, 'en', { numeric: 'true', sensitivity: 'base' }));
                    setScene({ width: window.innerWidth, height: window.innerHeight + batArr.length * 270 });

                    const pcsArr = data.filter(el => el.device_name.toLowerCase().startsWith('pv_pcs')
                    ).sort((a, b) => a.device_id.localeCompare(b.device_id, 'en', { numeric: 'true', sensitivity: 'base' }));

                    setDeviceList({ batArr, pcsArr, hybridPcs, multiMeter, weather });
                }
                setIsLoading(false);
            };

            fetchDevices(signal);
            return () => {
                controller.abort();
            };
        }//eslint-disable-next-line
    }, [props.deviceId]);

    const getColor = (data) => {
        if (data && !!data) {
            if (data.work_status === 0) {
                return '#548235';
            } else if (data.work_status === 1) {
                return '#BD1D1D';
            } else {
                return '#F6BE00';
            }
        }
    };

    return (<> {isLoading ? <Spinner /> :
        <Col style={{ 'height': "80vh" }}>
            <Stage
                id="koshigaya"
                width={scene.width}
                height={scene.height}
                scaleX={+stageScale}
                scaleY={+stageScale}
                onWheel={handleStageWheel}
                draggable={true}
                onDragStart={handleStageDragStart}
                onDragEnd={cursorGrab}
                onMouseOver={cursorGrab}
                onDragMove={handleStageDragMoveComn}
                onClick={(e) => console.log(e.target)}
            >
                <Layer>
                    {renderPcsComn([deviceList.pcsArr[0], deviceList.pcsArr[1], deviceList.pcsArr[2], deviceList.pcsArr[3], deviceList.pcsArr[4], deviceList.pcsArr[5], deviceList.pcsArr[6]], 200, 235, 'KICright')}
                    {renderPcsComn([deviceList.pcsArr[7], deviceList.pcsArr[8]], 500, 450, 'KICright')}

                    <Group x={700} y={10}>
                        <Group x={0} y={330} >

                            {/* {renderHybridPcs(deviceList)} */}
                        </Group>
                        <Group x={0} y={0} >
                            <Text x={360} y={355} text={'PW'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={370} y={560} text={'1'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={370} y={645} text={'2'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={370} y={715} text={'3'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={200} y={660} text={'6'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={200} y={720} text={'7'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={200} y={770} text={'8'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                        </Group>
                        <Group>
                            {/* ----------------outer dashed line------------- */}
                            <Line stroke="black" strokeWidth={1} points={[100, 100, 100, 860, 1390, 860, 1390, 100, 100, 100]} dash={[60, 15, 15, 18, 15, 18]} />
                        </Group>
                        <Group>

                            {/* -----------Top----------------- */}
                            <LoadImage src="/img/antena.png" x={615} y={-10} height={133 / 3} width={132 / 3} />
                            <Text x={655} y={5} text={'LTE'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={100} y={60} text={'遠隔監視装置盤(樹脂製)'} fill="black" fontSize={25} padding={10} lineHeight={0.75} />
                            <Text x={625} y={55} text={'外部アンテナ'} fill="black" fontSize={20} padding={10} lineHeight={0.75} />
                            <Rect x={605} y={35} width={20} strokeWidth={1} height={30} stroke="black" />
                            <Line stroke="#548235" strokeWidth={5} x={615} y={65} points={[1, 1, 1, 70]} />
                            <Line stroke="#548235" strokeWidth={5} x={1220} y={470} points={[-100, 10, 30, 10, 30, -50, 10, -65]} />
                            <Text x={1260} y={390} text={'MCB'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />


                            {/* ..............................AC 100/200V........................................... */}
                            <Group x={50} y={10}>
                                <Text x={1120} y={35} text={'AC 100V/200V   3W(交流集電盤より)'} fill="black" fontSize={25} padding={10} lineHeight={0.75} />

                                <Line stroke="#548235" strokeWidth={5} x={1200} y={65} points={[1, 1, 1, 320]} />
                                <Rect x={1155} y={140} width={100} strokeWidth={1} height={40} stroke="black" fill="white" />
                                <Text x={1180} y={145} text={'TB             *2'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                                <Text x={1200} y={305} text={'AC 100V    2W'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            </Group>
                            {/* --------------inner rectangle ----------------------------*/}
                            <Rect x={540} y={135} width={150} strokeWidth={1} height={50} stroke="black" />
                            <Text x={550} y={132} text={'      IDG-770\n\n(モバイルルータ)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                            {/* <Rect x={800} y={135} width={150} strokeWidth={1} height={50} stroke="black" />
                            <Text x={830} y={132} text={'ACアダプタ\n\n   (付属品)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} /> */}


                            <Rect x={522} y={550} width={170} strokeWidth={1} height={50} stroke="black" />
                            <Text x={530} y={550} text={'OpenBlocks IoT VX2 \n\n (SEMS デバイス)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />



                            <Rect x={522} y={700} width={170} strokeWidth={1} height={50} stroke="black" />
                            <Text x={530} y={700} text={'MGate MB3180 \n\n (RS485/LAN変換器)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                            {/* <Rect x={660} y={750} width={170} strokeWidth={1} height={50} stroke="black" />
                            <Text x={660} y={750} text={'MGate MB3280 \n\n (RS485/LAN変換器)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} /> */}

                            {/* ----------------inner dashed horizontal line------------- */}
                            <Line stroke="#548235" strokeWidth={5} x={660} y={100} points={[160, 60, 30, 60]} />
                            {/* <Line stroke="#548235" strokeWidth={5} x={920} y={100} points={[100, 60, 30, 60]} /> */}

                            <Line stroke="#548235" strokeWidth={5} x={440} y={200} points={[380, 60, 30, 60]} />
                            <Line stroke="#548235" strokeWidth={5} x={370} y={310} points={[450, 60, 30, 60]} />
                            <Line stroke="#548235" strokeWidth={5} x={840} y={100} points={[180, 60, 30, 60]} />
                            <Line stroke="#548235" strokeWidth={5} x={662} y={510} points={[360, 60, 30, 60]} />
                            <Line stroke="#548235" strokeWidth={5} x={662} y={670} points={[360, 60, 30, 60]} />
                            <Line stroke="#548235" strokeWidth={5} x={370} y={515} points={[153, 60, 30, 60]} dash={[10, 10]} />
                            <Line stroke="#548235" strokeWidth={5} x={370} y={670} points={[153, 60, 30, 60]} dash={[10, 10]} />

                            {/* <Line stroke="#548235" strokeWidth={5} x={340} y={120} points={[-400, 60, 100, 60, 100, 352, 50, 352]} dash={[10, 10]} /> */}
                            <Line stroke="#548235" strokeWidth={5} x={360} y={55} points={[-425, 60, 100, 60, 100, 220]} dash={[10, 10]} />
                            <Line stroke="#548235" strokeWidth={5} x={360} y={180} points={[-700, 60, 100, 60]} dash={[10, 10]} />
                            <Line stroke="#548235" strokeWidth={5} x={280} y={125} points={[-310, 60, 100, 60, 100, 120]} />

                            {/* <Line stroke="#548235" strokeWidth={5} x={-215} y={200} points={[-50, 30, 10, 70, 10, 100, -50, 100]} dash={[10, 10]} /> */}

                            <Line stroke="#548235" strokeWidth={5} x={-100} y={200} points={[400, 70, 150, 70, 150, 260, 30, 260]} dash={[10, 10]} />

                            {/* <Line stroke="#548235" strokeWidth={5} x={-215} y={430} points={[-50, 30, 10, 70, 10, 100, -50, 100]} dash={[10, 10]} /> */}

                            <Line stroke="#548235" strokeWidth={5} x={-100} y={615} points={[300, 60, 20, 60, 20, 180, -145, 180]} dash={[10, 10]} />
                            <Line stroke="#548235" strokeWidth={5} x={-215} y={800} points={[-50, -10, 10, 40, 10, 170, -30, 170]} dash={[10, 10]} />


                            <Line stroke="#548235" strokeWidth={5} x={-555} y={695} points={[153, 60, 90, 60]} dash={[10, 10]} />
                            <Line stroke="#548235" strokeWidth={5} x={-555} y={725} points={[153, 60, 90, 60]} dash={[10, 10]} />
                            <Line stroke="#548235" strokeWidth={5} x={-555} y={775} points={[153, 60, 90, 60]} dash={[10, 10]} />

                            <Line stroke="#548235" strokeWidth={5} x={-555} y={875} points={[153, 60, 90, 60]} dash={[10, 10]} />
                            <Line stroke="#548235" strokeWidth={5} x={-555} y={905} points={[153, 60, 90, 60]} dash={[10, 10]} />
                            <Line stroke="#548235" strokeWidth={5} x={-555} y={955} points={[153, 60, 90, 60]} dash={[10, 10]} />


                            {/* ------------------text inside dashed line-------------- */}
                            <Text x={630} y={230} text={'LAN'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={580} y={180} text={'LAN'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={450} y={320} text={'LAN'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            {/* <Text x={420} y={440} text={'LAN'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} /> */}
                            <Text x={470} y={550} text={'LAN'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={470} y={700} text={'LAN'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={570} y={670} text={'RS485'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                            <Line stroke="#548235" strokeWidth={5} x={568} y={162} points={[10, 20, 10, 100,]} dash={[14, 14]} />
                            {/* <Circle x={575} y={215} radius={10} stroke="black" strokeWidth={1} dash={[20, 20]} rotation={190} /> */}
                            {/* <Line stroke="black" strokeWidth={1} x={577} y={223} points={[1, 1, 1, 30,]} dash={[17, 17]} /> */}
                            <Circle x={573} y={260} radius={10} stroke="#548235" strokeWidth={5} dash={[20, 20]} rotation={190} />
                            <Line stroke="#548235" strokeWidth={5} x={577} y={270} points={[1, 1, 1, 90]} dash={[17, 17]} />
                            <Circle x={573} y={370} radius={10} stroke="#548235" strokeWidth={5} dash={[20, 20]} rotation={190} />
                            <Line stroke="#548235" strokeWidth={5} x={577} y={380} points={[1, 1, 1, 50]} dash={[17, 17]} />
                            <Circle x={573} y={440} radius={10} stroke="#548235" strokeWidth={5} dash={[20, 20]} rotation={190} />
                            <Line stroke="#548235" strokeWidth={5} x={577} y={450} points={[1, 1, 1, 105]} dash={[17, 17]} />

                            {/* ------------EDS------------------ */}
                            <Rect x={200} y={350} width={200} strokeWidth={1} height={470} stroke="black" />
                            <Text x={300} y={650} text={'       EDS-208 \n\n (スイッチング HUB)\n\n        8ボ -ト'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} rotation={270} />

                            {/* ------------UPS------------------ */}
                            <Rect x={1020} y={135} width={100} strokeWidth={1} height={670} stroke="black" />
                            <Text x={1020} y={350} text={'    UPS \n\n BY35S'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                            {/* ------------TB------------------ */}
                            <Rect x={820} y={130} width={50} strokeWidth={1} height={250} stroke="black" />
                            <Text x={820} y={230} text={' TB \n\n *1'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                            {/* ------------MDR------------------ */}
                            <Rect x={910} y={130} width={55} strokeWidth={1} height={130} stroke="black" fill="white" />
                            <Text x={907} y={255} text={'MDR-40-24\n\n (DC電源)'} fill="black" fontSize={19} padding={10} lineHeight={0.75} rotation={270} />

                            <Rect x={772} y={550} width={170} strokeWidth={1} height={50} stroke="black" fill="white" />
                            <Text x={810} y={550} text={'ACアダプタ\n\n   (付属品)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                            <Rect x={772} y={700} width={170} strokeWidth={1} height={50} stroke="black" fill="white" />
                            <Text x={810} y={700} text={'ACアダプタ\n\n   (付属品)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Rect x={300} y={230} width={170} strokeWidth={1} height={50} stroke="black" fill="white" />
                            <Text x={300} y={230} text={'Smartlogger 3000 \n\n         (Huawei)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />


                        </Group>
                        {/* -----------------------------------Outer Rectangle------------------------------------- */}
                        <Group>

                            <Rect x={-300} y={90} width={270} strokeWidth={1} height={50} stroke="#4B752F" fill={deviceList.multiMeter ? getColor(deviceList.multiMeter[0]) : "white"} />
                            <Text x={-190} y={90} text={deviceList.multiMeter ? deviceList.multiMeter[0].device_id : 'MMR'} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                            <Text x={-265} y={110} text={'(主幹用マルチメーター)'} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                            <Text x={-30} y={90} text={'RS485'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                            <Rect x={-130} y={170} width={100} strokeWidth={2} height={30} stroke="black" fill="white" />
                            <Text x={-130} y={170} text={'気温計'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={120} y={155} text={'専用 ケーブル (PT-100)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            {/* <Text x={-30} y={115} text={'FCPEV-S 0.9-3P'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} /> */}

                            {/* <Rect x={-300} y={150} width={270} strokeWidth={1} height={50} stroke="black" fill="white" />
                            <Text x={-245} y={160} text={'既設高圧盤RPR信号'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={-30} y={155} text={'DI信号'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={-30} y={180} text={'FCPEV-S 0.9-3P'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} /> */}

                            {/* <Rect x={-450} y={210} width={200} strokeWidth={1} height={50} stroke="black" fill="white" />
                            <Rect x={-450} y={290} width={200} strokeWidth={1} height={50} stroke="black" fill="white" /> */}
                            <Text x={230} y={215} text={'RS485'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                            {/* <Text x={-430} y={220} text={'PV 111.1kW PCS1-1'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={-430} y={300} text={'PV 111.1kW PCS1-2'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} /> */}

                            {/* <Text x={-210} y={215} text={'RS485'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={-210} y={240} text={'FCPEV-S 0.9-3P'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} /> */}

                            {/* <Rect x={-450} y={430} width={200} strokeWidth={1} height={50} stroke="black" fill="white" />
                            <Rect x={-450} y={510} width={200} strokeWidth={1} height={50} stroke="black" fill="white" /> */}
                            <Text x={230} y={245} text={'RS485'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            {/* <Text x={-430} y={440} text={'PV 4. 95kW PCS3-1'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={-430} y={520} text={'PV 4. 95kW PCS3-2'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} /> */}

                            {/* <Text x={-210} y={435} text={'RS485'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={-210} y={460} text={'FCPEV-S 0.9-3P'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} /> */}

                            <Text x={-80} y={645} text={'LAN'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            {/* <Text x={-80} y={675} text={'UTP0. 5-4P(CAT5E)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} /> */}

                            {/* <Text x={-200} y={870} text={'LAN'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={-200} y={890} text={'UTP0. 5-4P(CAT5E)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} /> */}

                            <Rect x={-400} y={740} width={150} strokeWidth={1} height={120} stroke="#4B752F" fill={getColor(deviceList.batArr[0])} />
                            {/* <Text x={-390} y={770} text={'ストレージPCS'} fill="white" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} /> */}
                            <Text x={-370} y={780} text={deviceList.batArr[0].device_id} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />

                            <Rect x={-620} y={740} width={150} strokeWidth={1} height={60} stroke="black" fill="white" />
                            <Rect x={-620} y={810} width={150} strokeWidth={1} height={50} stroke="black" fill="white" />
                            <Text x={-610} y={755} text={'自立運転切替盤1'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={-600} y={820} text={'バッテリー1'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={-465} y={730} text={'RS485'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={-465} y={760} text={'CAN'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={-465} y={810} text={'CAN'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                            <Rect x={-400} y={920} width={150} strokeWidth={1} height={120} stroke="#4B752F" fill={getColor(deviceList.batArr[1])} />
                            {/* <Text x={-390} y={950} text={'ストレージPCS'} fill="white" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} /> */}
                            <Text x={-370} y={960} text={deviceList.batArr[1].device_id} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />

                            <Rect x={-620} y={920} width={150} strokeWidth={1} height={60} stroke="black" fill="white" />
                            <Rect x={-620} y={990} width={150} strokeWidth={1} height={50} stroke="black" fill="white" />
                            <Text x={-610} y={930} text={'自立運転切替盤2'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={-600} y={1000} text={'バッテリー2'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={-465} y={910} text={'RS485'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={-465} y={940} text={'CAN'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            <Text x={-465} y={990} text={'CAN'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />


                        </Group>


                        {/* ---------------Lower part---------------------- */}
                        <Group x={-100} y={150} >
                            <Line stroke="#548235" strokeWidth={5} x={700} y={600} points={[1, 1, 1, 150]} dash={[10, 10]} />


                            <Group x={-300} y={-25}>
                                <Rect x={925} y={780} width={150} strokeWidth={2} height={50} stroke="#4B752F" fill={deviceList.weather ? getColor(deviceList.weather[0]) : "white"} />
                                {/* <Text x={1005} y={730} text={'FCPEV-S 0. 9-3P'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} /> */}
                                <Text x={1005} y={755} text={'RS485'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                                <Text x={950} y={775} text={'    WMR\n\n(TD-BOX)'} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />

                                <Line stroke="#548235" strokeWidth={5} x={690} y={750} points={[230, 60, 30, 60]} dash={[10, 10]} />
                                <Rect x={620} y={795} width={100} strokeWidth={2} height={30} stroke="black" fill="white" />
                                <Text x={635} y={795} text={'日射計'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                                <Text x={730} y={785} text={'専用 ケーブル'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                                {/* <Line stroke="#548235" strokeWidth={5} x={1000} y={830} points={[1, 1, 1, 60]} />
                                <Line stroke="#548235" strokeWidth={5} x={700} y={830} points={[300, 60, 30, 60]} />
                                <Rect x={620} y={875} width={100} strokeWidth={2} height={30} stroke="black" fill="white" />
                                <Text x={635} y={875} text={'気温計'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                                <Text x={730} y={865} text={'専用 ケーブル (PT-100)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} /> */}

                                <Line stroke="#548235" strokeWidth={5} x={1045} y={750} points={[200, 60, 30, 60]} />
                                <Text x={1240} y={795} text={'AC100V(交流集電盤より)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                            </Group>
                        </Group>
                    </Group>
                </Layer>
            </Stage>
        </Col>
    }
    </>
    );

};

export default ComnKoshigaya;